import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    topbarContainer: {
        width: '1080px',
    },
    sideMenuIcon: {
        color: 'white',
        background: '#013358',
        height: '83px',
        cursor: 'pointer',
        padding: '10px 15px',
        borderRadius: 0,
        position: 'fixed',
        zIndex: 1300,
    },
    icon: {
        fontSize: '60px',
        color: 'white',
        background: '#013358',
        height: '83px',
        cursor: 'pointer',
        padding: '10px 15px',
        borderRadius: 0,
    },
    contentWrapper: {
        backgroundColor: '#013358',
    },
    items: {
        width: '100%',
        height: '152px',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        padding: '10px',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        boxShadow: '0 15px 10px 0 rgba(0, 0, 0, 0.43)',
    },
    item: {
        cursor: 'pointer',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'inherit',
        textAlign: 'center',
        fontSize: '17px',
        fontWeight: 'normal',
        lineHeight: '1.47',
        color: '#e0e5e5',
        '&$selected': {
            color: '#ffb607',
            borderBottom: '4px solid #ffb607',
        },
        '& .media': {
            minHeight: '35px',
            height: '35px',
            marginBottom: '10px',
            color: '#ffb607',
        },
    },
    drawer: {
        width: '100%',
    },
    open: {
        transform: 'translateX(0)',
    },
})

export default useStyles
